import * as React from "react";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import sanitizeHtml from "sanitize-html";
import { Parser } from "html-to-react";
export type RadioItem = { id: string; label: string };

type Props = {
  options: Array<RadioItem>;
  defaultValue: string;
  disabled?: boolean;
  onChange: (value: string) => void;
  value?: string;
};

export default function RadioButtonsGroup(props: Props) {
  const getAlphabetLetter = (index: number): string => {
    if (index >= 1 && index <= 26) {
      return String.fromCharCode(64 + index).toUpperCase() + ". ";
    } else {
      return "";
    }
  };

  const getLabel = (item: RadioItem, index: number) => {
    const label = Parser().parse(sanitizeHtml(item.label));

    if (props.options.length === 2) {
      return label;
    }

    return getAlphabetLetter(index + 1) + label;
  };

  const getRadio = () => (
    <Radio
      disabled={props.disabled}
    />
  );

  const getReadOnlyRadio = (value: string) => (
    <Radio
      checked={value === props.value}
    />
  );

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    props.onChange((event.target as HTMLInputElement).value);
  };

  return (
    <FormControl>
      <RadioGroup
        aria-labelledby="demo-radio-buttons-group-label"
        name="radio-buttons-group"
        onChange={handleChange}
      >
        {props.options.map((option, index) => (
          <FormControlLabel
            value={option.id}
            control={props.value ? getReadOnlyRadio(option.id) : getRadio()}
            label={getLabel(option, index)}
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
